<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>On retiring, Colin Cossor studied for a BA in English and an MA in creative writing. After living in North London for 50 years, he has now moved to Suffolk, where he spends his time—when not writing—painting the landscape and walking with Paddy, his Jack Russell Terrier.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6eb9c893